// get text, slice it base on the length, then return a sliced text

export const slicedText = (text, maxLength) => {

    return `${text.slice(0, maxLength)}...`;
}